import React, { useEffect, useState } from "react";

import styles from "./Login.module.css";
import ForexLogo from "../assests/ForexLogo.svg";
import server from "../utils/serverConfig";
import apiClient from "../utils/apiClient";

import { FcGoogle } from "react-icons/fc";

import { IoIosArrowBack } from "react-icons/io";
import firebase from "firebase/compat/app";
import { PiCaretDown, PiCaretUp } from "react-icons/pi";
import { motion } from "framer-motion";

import SignInEmail from "./signInEmail";
import { auth, provider } from "./firebase";
import { CountryCode } from "./CountryCode";
import Timer from "./Timer";
import SignUpEmail from "./SignUpEmail";
import ForgotPassword from "./forgotPassword";
import { onAuthStateChanged } from "firebase/auth";

const style = {
  selectDiv:
    "flex items-center px-2 py-2  rounded-lg mx-3 md-3 text-black-500  hover:bg-black/10 hover:text-black-500  ease-linear duration-150 cursor-pointer",
  loginBorder: "",
};

export default function LoginPage(props) {
  // login with gmail start
  // const handleGmailLogin = async () => {
  //   auth
  //     .signInWithPopup(provider)
  //     .then(async (response) => {
  //       if (response) {
  //         console.log("respinse", response);
  //         // const id = uuidv4();
  //         // const formRequestUserAccount = {
  //         //   id: id,
  //         //   username: response.additionalUserInfo.profile.name,
  //         //   email: response.additionalUserInfo.profile.email,
  //         // };

  //         // const accountResponse = await fetch("/api/user", {
  //         //   method: "POST",
  //         //   headers: {
  //         //     "Content-Type": "application/json",
  //         //   },
  //         //   body: JSON.stringify(formRequestUserAccount),
  //         // });
  //         // const userAccountData = await accountResponse.json();

  //         // console.log("Response Data For User Account", userAccountData);
  //         // toast.success("Signup Successful !!", {
  //         //   duration: 2000,
  //         // });
  //       }
  //     })
  //     .catch(alert);
  // };

  // Updated handleGmailLogin function with domain restriction

  // Updated handleGmailLogin function with domain restriction
  // Add this state to your component
  const [isValidating, setIsValidating] = useState(false);
  const [allowedEmails, setAllowedEmails] = useState([]);

  useEffect(() => {
    const fetchAllowedEmails = async () => {
      try {
        const response = await apiClient.get("allowed-emails");
        const data = response.data;
        if (data.status === "success") {
          setAllowedEmails(data.emails);
        }
      } catch (error) {
        console.error("Error fetching allowed emails:", error);
      }
    };
    fetchAllowedEmails();
  }, []);

  const handleGmailLogin = async () => {
    // const allowedDomains = ["iamclearmind.com", "sypto.xyz"];

    setIsValidating(true); // Set flag to prevent premature redirection

    auth
      .signInWithPopup(provider)
      .then(async (response) => {
        if (response) {
          console.log("response", response);

          // Get the user's email
          const userEmail =
            response.user.email || response.additionalUserInfo?.profile?.email;

          if (userEmail) {
            // Extract domain from email
            const emailDomain = userEmail.split("@")[1];

            // Check if email is allowed AND domain is iamclearmind.com
            if (emailDomain === "iamclearmind.com" && allowedEmails.includes(userEmail)) {
              console.log("Login successful for allowed email:", userEmail);
              
              // Fetch specific user access
              try {
                const accessResponse = await apiClient.get(`user-access?email=${userEmail}`);
                if (accessResponse.data.status === "success") {
                  localStorage.setItem("user_access", JSON.stringify(accessResponse.data.access));
                  console.log("User access stored:", accessResponse.data.access);
                }
              } catch (accessError) {
                console.error("Error fetching user access:", accessError);
              }

              setIsValidating(false); // Clear flag - allow normal auth flow
              // Your success logic here
            } else {
              // Domain not allowed - delete user account and show error
              const user = response.user;
              try {
                // Delete the user account from Firebase
                await user.delete();
                setIsValidating(false);
                console.log("Unauthorized user account deleted:", emailDomain);
                window.location.href = "/"; // Redirect to home or login page
              } catch (deleteError) {
                console.error("Error deleting user:", deleteError);
                // Fallback to sign out if delete fails
                await auth.signOut();
                setIsValidating(false);
                window.location.href = "/";
              }
              setIsValidating(false); // Clear flag
              alert(`Access denied. Email Not verified.`);
              console.log("Login denied for domain:", emailDomain);
            }
          } else {
            // No email found
            try {
              await response.user.delete();
            } catch (error) {
              await auth.signOut();
            }
            setIsValidating(false); // Clear flag
            alert("Unable to retrieve email information. Please try again.");
          }
        }
      })
      .catch((error) => {
        console.error("Login error:", error);
        setIsValidating(false); // Clear flag
        alert("Login failed. Please try again.");
      });
  };

  // Then in your auth state listener, check the validation flag:
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && !isValidating) {
        // Only proceed with auth flow if not currently validating
        // Your redirect/auth logic here

      } else if (!user) {
        // Handle signed out state
      }
      // If isValidating is true, do nothing - wait for validation to complete
    });

    return () => unsubscribe();
  }, [isValidating]);

  //login with gmail end

  //login with otp start
  const [mobileShow, setMobileShow] = useState(false);
  const [number, setNumber] = useState();
  const [otpEntered, setOtpEntered] = useState();
  const [otpSent, setOtpSent] = useState(false);
  const [dialogBoxVisibility, setDialogBoxVisibility] = useState(false);
  const [token, setToken] = useState();
  const [countryCode, setCountryCode] = useState("+91");
  const [showCountryCode, setShowCountryCode] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);

  const getOTPassword = () => {
    return new Promise((resolve, reject) => {
      if (otpEntered.length === 6) {
        resolve(otpEntered);
      } else {
        reject(0);
      }
    });
  };
  const setUpRecaptcha = () => {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recptcha-container",
      {
        size: "invisible",
        callback: function (response) {
          onSignInSubmit();
          onSignInSubmitEnter();
        },
      }
    );
  };

  const onSignInSubmitEnter = () => {
    setUpRecaptcha();
    setOtpSent(true);
    if (number.length !== 10) {
      alert(number + " Invalid Number");
      setOtpSent(false);
    } else {
      runCaptcha();
    }
  };

  const onSignInSubmit = (event) => {
    event.preventDefault();
    setUpRecaptcha();
    setOtpSent(true);
    if (number.length !== 10) {
      alert(number + " Invalid Number");
      setOtpSent(false);
    } else {
      runCaptcha();
    }
  };
  const runCaptcha = () => {
    var phoneNumber = countryCode + number;
    var appVerifier = window.recaptchaVerifier;
    firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then((confirmationResult) => {
        setDialogBoxVisibility(true);
        setToken(confirmationResult);
      });
  };

  const submitOTP = async () => {
    setAuthenticating(true);
    let confirmationResult = token;
    window.confirmationResult = confirmationResult;
    await getOTPassword()
      .then((code) => {
        confirmationResult
          .confirm(code)
          .then((result) => {
            // this.setState({ user: result.user });
            console.log("result", result);
            // const user = this.removeISDCode(result.user);
            // this.props.createOrFetchUserData(user);
            // this.context.router.push("/");
            props.setShow(false);
            setMobileShow(false);
            setDialogBoxVisibility(false);
            setOtpSent(false);
            setNumber("");
          })
          .catch(function (error) {
            if (error.code === "auth/invalid-verification-code") {
              alert("Invalid OTP, Please check again or resend OTP");
            }
          });
      })
      .catch((err) => {
        alert("incorrect OTP Entered");
      });
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      submitOTP();
    }
  };
  const handleKeyPressSendOtp = (event) => {
    if (event.key === "Enter") {
      onSignInSubmitEnter();
    }
  };
  //login with otp end

  const [signUpMethodOpen, setSignUpMethodOpen] = useState(false);
  const [openForgotPassword, setOpenForgotPassword] = useState(false);
  return (
    <div
      className={` bg-hero min-h-screen w-full flex items-center justify-center`}
    >
      <div className="flex w-full justify-center items-center">
        <div
          className={` backdrop-blur-md bg-white/10 rounded-lg w-1/3 flex flex-col justify-center items-center px-12 py-10`}
        >
          <img src={ForexLogo} alt="Forex Logo" />{" "}
          {mobileShow === true ? (
            <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">
              <div
                onClick={() => {
                  setMobileShow(false);
                  setDialogBoxVisibility(false);
                  setOtpSent(false);
                  setNumber("");
                }}
                className="h-10 w-10 flex flex-row justify-center items-center rounded-full   text-black/70 absolute top-0 -left-4  m-1 font-bold hover:text-[#07F2C7]  ease-linear duration-150 cursor-pointer"
              >
                <div>
                  <IoIosArrowBack size={25} />
                </div>
              </div>

              <div id="recptcha-container"></div>
              <div className="pt-8"></div>
              <div className="w-full bg-[#F7F7F7] flex flex-row items-center px-6 mt-8 rounded-[8px]">
                <div
                  className={`w-[25%] text-[#000000]/80 flex flex-row items-center relative cursor-pointer`}
                  onClick={() => setShowCountryCode(!showCountryCode)}
                >
                  <div className="text-[#000000]/80">{countryCode}</div>

                  <div
                    className={`pl-1 ease-linear duration-150 text-[#000000]/25`}
                  >
                    {showCountryCode ? (
                      <PiCaretUp size={20} />
                    ) : (
                      <PiCaretDown size={20} />
                    )}
                  </div>
                </div>
                {showCountryCode && (
                  <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, type: "spring" }}
                    exit={{ y: -50, opacity: 0 }}
                    className="absolute right-0 top-12 bg-white flex flex-col rounded-lg w-[100%] pt-2 pb-2 z-10 box-border border-2 border-solid border-[ rgba(185, 192, 187, 0.7)] "
                  >
                    {CountryCode.map((ele) => {
                      return (
                        <div
                          className={`pl-3 font-medium ${style.selectDiv}`}
                          onClick={() => {
                            setCountryCode(ele.value);
                            setShowCountryCode(false);
                          }}
                        >
                          {ele.value} {ele.label}
                        </div>
                      );
                    })}
                  </motion.div>
                )}
                <input
                  placeholder="Enter your phone number"
                  className="w-[75%] bg-[#F7F7F7] text-[#000000]/80 py-2 pl-4 text-lg my-1 border-l-[1px] border-[#000000]/40"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  type="number"
                  onKeyPress={handleKeyPressSendOtp}
                />
              </div>

              {dialogBoxVisibility === true ? (
                <div onKeyPress={handleKeyPress} className="w-full">
                  <input
                    placeholder="Enter 6 digit code"
                    className="w-full bg-[#F7F7F7] text-[#000000]/80 py-3 px-8 mt-3 rounded-lg"
                    value={otpEntered}
                    onChange={(e) => setOtpEntered(e.target.value)}
                    type="text"
                  />
                  <div
                    className="flex flex-row justify-center bg-[#07F2C7] text-black text-lg rounded-[8px] px-4 py-2 mt-4 cursor-pointer font-semibold"
                    onClick={submitOTP}
                  >
                    {authenticating === true
                      ? "Authenticating ......."
                      : "Submit otp"}
                  </div>
                  <Timer resend={runCaptcha} />
                </div>
              ) : (
                <div className="w-full">
                  {otpSent === true ? (
                    <div className="flex flex-row justify-center bg-[#07F2C7] text-black text-lg rounded-[8px] px-4 py-2 mt-4 cursor-pointer">
                      Sending Otp ...
                    </div>
                  ) : (
                    <div
                      className="w-full flex flex-row justify-center bg-[#07F2C7] text-black text-lg rounded-[8px] px-4 py-2.5 mt-4 cursor-pointer font-semibold"
                      onClick={onSignInSubmit}
                    >
                      Get otp
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : signUpMethodOpen === true ? (
            <SignUpEmail allowedEmails={allowedEmails} setSignUpMethodOpen={setSignUpMethodOpen} />
          ) : openForgotPassword === true ? (
            <ForgotPassword setOpenForgotPassword={setOpenForgotPassword} />
          ) : (
            <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">
              <div
                className="bg-white rounded-[8px] shadow-xl text-base flex flex-row justify-center py-2.5 w-full mt-8 cursor-pointer"
                onClick={handleGmailLogin}
              >
                <div>
                  <FcGoogle size={25} />
                </div>
                <div className="ml-4 text-lg font-semibold text-black">
                  Sign In with Google
                </div>
              </div>
              {/* <div
                className="bg-white rounded-[8px] shadow-xl text-base flex flex-row justify-center py-2.5 w-full mt-4 cursor-pointer"
                onClick={() => setMobileShow(true)}
              >
                <div className="ml-4 text-lg font-semibold text-black">
                  Sign In with OTP
                </div>
              </div> */}
              {/* <div className={`py-4 ${styles.centerseparatorMobile}`}> */}
              {/* <div className={styles.centerText}>or</div> */}
              {/* </div> */}
              <SignInEmail allowedEmails={allowedEmails} setOpenForgotPassword={setOpenForgotPassword} />
              {/* <div className="text-[#ffffff] text-base w-full flex justify-start">
                Don’t have an account?{" "}
                <div
                  className="text-[#07F2C7] cursor-pointer"
                  onClick={() => setSignUpMethodOpen(true)}
                >
                  Sign up
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
